module.exports = __webpack_public_path__ + "static/media/halo-clean.438a09b7.svg";